
export const addressMapping = {
  "Norte 45 847": "Norte 45 847 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
  "Poniente 128 No. 550": "Calle Pte. 128 550 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
  "Calzada Vallejo No. 1849": "Calz. Vallejo 1849 San José de la Escalera, Gustavo A. Madero, 07630 Ciudad de México, CDMX"
};

export const originAddressOptions = [
  { value: "Norte 45 847", label: "Norte 45 847" },
  { value: "Poniente 128 No. 550", label: "Poniente 128 No. 550" },
  { value: "Calzada Vallejo No. 1849", label: "Calzada Vallejo No. 1849" }
];
export const BASE_ADDRESSES_SHORT = [
  "Norte 45 847",
  "Poniente 128 No. 550",
  "Calzada Vallejo No. 1849"
];

export const BASE_ADDRESSES_FULL = [
  "Norte 45 847 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
  "Calle Pte. 128 550 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
  "Calz. Vallejo 1849 San José de la Escalera, Gustavo A. Madero, 07630 Ciudad de México, CDMX"
];

export const normalizeAddress = (address) => {
  if (!address) return '';
  
  let normalized = address
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, ' ')
    .replace(/[.,#]/g, '')
    .replace(/no\.?/gi, '')
    .replace(/calzada/gi, 'calz')
    .replace(/calz\.?/gi, 'calz')
    .replace(/poniente/gi, 'pte')
    .replace(/pte\.?/gi, 'pte')
    .replace(/calle/gi, '')
    .replace(/industrial vallejo/gi, '')
    .replace(/azcapotzalco/gi, '')
    .replace(/ciudad de mexico/gi, '')
    .replace(/cdmx/gi, '')
    .trim();
  
  return normalized;
};

export const isBaseAddress = (address) => {
  if (!address) return false;
  
  const normalizedInput = normalizeAddress(address);
  
  return BASE_ADDRESSES_SHORT.some(baseAddress => {
    const normalizedBase = normalizeAddress(baseAddress);
    
    if (normalizedInput === normalizedBase) {
      return true;
    }
    
    const inputNumbers = normalizedInput.match(/\d+/g) || [];
    const baseNumbers = normalizedBase.match(/\d+/g) || [];
    
    if (inputNumbers.length > 0 && baseNumbers.length > 0) {
      const hasMatchingNumbers = baseNumbers.some(num => 
        inputNumbers.includes(num)
      );
      
      const keywords = ['norte', '45', '847', 'poniente', '128', '550', 'calz', 'vallejo', '1849'];
      const hasKeywords = keywords.some(keyword => 
        normalizedInput.includes(keyword) && normalizedBase.includes(keyword)
      );
      
      if (hasMatchingNumbers && hasKeywords) {
        return true;
      }
    }
    
    const similarity = calculateSimilarity(normalizedInput, normalizedBase);
    if (similarity > 0.6) {
      return true;
    }
    
    return false;
  });
};

export const getFullBaseAddress = (shortAddress) => {
  return addressMapping[shortAddress] || shortAddress;
};

export const BASE_ADDRESSES = BASE_ADDRESSES_SHORT;

const calculateSimilarity = (str1, str2) => {
  if (!str1 || !str2) return 0;
  
  const longer = str1.length > str2.length ? str1 : str2;
  const shorter = str1.length > str2.length ? str2 : str1;
  
  if (longer.length === 0) return 1.0;
  
  return (longer.length - editDistance(longer, shorter)) / parseFloat(longer.length);
};

const editDistance = (str1, str2) => {
  const matrix = [];
  
  for (let i = 0; i <= str2.length; i++) {
    matrix[i] = [i];
  }
  
  for (let j = 0; j <= str1.length; j++) {
    matrix[0][j] = j;
  }
  
  for (let i = 1; i <= str2.length; i++) {
    for (let j = 1; j <= str1.length; j++) {
      if (str2.charAt(i-1) === str1.charAt(j-1)) {
        matrix[i][j] = matrix[i-1][j-1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i-1][j-1] + 1,
          matrix[i][j-1] + 1,
          matrix[i-1][j] + 1
        );
      }
    }
  }
  
  return matrix[str2.length][str1.length];
};
